export function formatDateTime(
    date: Date,
    {
        locale = 'en-US',
        timeZone,
        omitTime = false,
    }: {
        locale?: string;
        timeZone?: string;
        omitTime?: boolean;
    } = {},
): string {
    try {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }

        const options: Intl.DateTimeFormatOptions = {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
        };

        if (!omitTime) {
            options.hour = 'numeric';
            options.minute = 'numeric';
            options.hour12 = true;
        }

        if (timeZone) {
            options.timeZone = timeZone;
        }

        const formatted = new Intl.DateTimeFormat(locale, options).format(date);

        if (omitTime) {
            return formatted;
        }

        return formatted
            .replace(/,([^,]*)$/, '$1') // remove comma before time
            .replace(/([AP])M/, (period) => period.toLowerCase())
            .replace(/,?\s*(\d+:\d+)/, '・$1') // add dot separator before time
            .replace(/ at\s*・/i, '・'); // handle alternate format like "at・"
    } catch (error) {
        return '';
    }
}
